import { useEffect, useState } from 'react';

export const useLoadGoogleMaps = (apiKey: string) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window?.['google'] && window?.['google']?.maps && window?.['google']?.maps?.places) {
      setLoaded(true);
      return;
    }
 
 const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    if(apiKey){
      script.onload = () => setLoaded(true);
    }
    document.body.appendChild(script);



    return () => {
      document.body.removeChild(script);
    };
  }, [apiKey]);

  return loaded;
}
